import React from 'react';

const ContactMap = () => {
    return (
        <>
            <div className="map-area">
                <iframe 
                    title="Address"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d278.7392527610149!2d-122.45068985699409!3d37.77657050886289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085874a311220bb%3A0x6a56ca6f837ff84e!2sUniversity%20of%20San%20Francisco!5e0!3m2!1sen!2sbd!4v1663929881467!5m2!1sen!2sbd">
                </iframe>
            </div>
        </>
    )
}

export default ContactMap;